var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const HdcpVersions = [
  // '1.0',
  // '1.1',
  // '1.2',
  // '1.3',
  "1.4",
  //'2.0',
  //'2.1',
  "2.2"
  // '2.3',
];
var ContentType = /* @__PURE__ */ ((ContentType2) => {
  ContentType2["AVC_BASELINE_L3"] = 'video/mp4; codecs="avc1.42001e"';
  return ContentType2;
})(ContentType || {});
let cachedInfo;
function createDeviceCapabilitiesHook(avia, options = {}) {
  const system = avia.getSystemInfo();
  const { DrmType, DrmKeySystemAvailability, DrmRobustness: DrmRobustness2, HdcpStatus, Platform, Browser } = avia;
  const keySystems = options.keySystems || [DrmType.WIDEVINE, DrmType.PLAYREADY, DrmType.PLAYREADY_REC];
  const contentType = options.contentType || ContentType.AVC_BASELINE_L3;
  return (context) => __async(this, null, function* () {
    const { value } = context;
    if (cachedInfo) {
      value.drm = cachedInfo;
      return;
    }
    const isMacSafari = system.isDesktop && system.platform === Platform.MAC && system.browser === Browser.SAFARI;
    if (system.isIos || isMacSafari) {
      value.drm.keySystemStatus = [{
        keySystem: DrmType.FAIRPLAY_1_0,
        availability: DrmKeySystemAvailability.INFERRED,
        robustness: DrmRobustness2.HW_SECURE_ALL
      }];
      value.drm.hdcpStatus = [{ version: "1.4", status: HdcpStatus.UNKNOWN }, { version: "2.2", status: HdcpStatus.UNKNOWN }];
    } else {
      const results = yield testKeySystems(keySystems, contentType, avia);
      cachedInfo = results;
      value.drm = results;
    }
    cachedInfo = value.drm;
  });
}
function testKeySystems(keySysNames, videoContentType, avia) {
  return __async(this, null, function* () {
    const KeySystems = [
      avia.DrmType.WIDEVINE,
      avia.DrmType.PLAYREADY,
      avia.DrmType.PLAYREADY_REC
    ];
    const keySystems = keySysNames || KeySystems;
    const secLevels = [
      avia.DrmRobustness.SW_SECURE_CRYPTO,
      avia.DrmRobustness.SW_SECURE_DECODE,
      avia.DrmRobustness.HW_SECURE_CRYPTO,
      avia.DrmRobustness.HW_SECURE_DECODE,
      avia.DrmRobustness.HW_SECURE_ALL
    ];
    const contentType = videoContentType || ContentType.AVC_BASELINE_L3;
    const getConfig = (robustness) => {
      return {
        initDataTypes: ["cenc"],
        videoCapabilities: [
          {
            contentType,
            robustness
          }
        ]
      };
    };
    const testSystem = (keySystem, config) => __async(this, null, function* () {
      const support = {};
      try {
        const access = yield navigator.requestMediaKeySystemAccess(keySystem, config);
        const mk = yield access.createMediaKeys();
        support.robustness = config[0].videoCapabilities[0].robustness;
        if (mk == null ? void 0 : mk.getStatusForPolicy) {
          const hdcp = ["1.4", "2.2"];
          const p = hdcp.map((v) => mk.getStatusForPolicy({ minHdcpVersion: v }).catch(() => {
          }));
          try {
            const r = yield Promise.all(p);
            support["1.4"] = r[0];
            support["2.2"] = r[1];
          } catch (error) {
          }
        }
      } catch (e) {
        support.error = e.message;
      }
      return support;
    });
    const results = {};
    const n = keySystems.length;
    for (let i = 0; i < n; i++) {
      const nn = secLevels.length;
      const sys = keySystems[i];
      results[sys] = [];
      for (let j = 0; j < nn; j++) {
        const r = yield testSystem(sys, [getConfig(secLevels[j])]);
        results[sys].push(r);
        if (r.error) {
          break;
        }
      }
    }
    return parseResultData(results, avia);
  });
}
function parseResultData(result, avia) {
  const statusArray = [];
  let hdcpStatus = null;
  const STAT_UNK = avia.HdcpStatus.UNKNOWN;
  const defaultHdcpStatus = [{ version: "1.4", status: STAT_UNK }, { version: "2.2", status: STAT_UNK }];
  Object.keys(result).forEach((keySystem) => {
    const statusObj = {
      keySystem,
      availability: avia.DrmKeySystemAvailability.UNKNOWN,
      robustness: avia.DrmRobustness.UNKNOWN
    };
    statusArray.push(statusObj);
    const arr = result[keySystem];
    const n = arr.length;
    for (let i = 0; i < n; i++) {
      const o = arr[i];
      if (i === 0 && !o.error) {
        statusObj.availability = avia.DrmKeySystemAvailability.DETECTED;
      }
      if (o.error) {
        break;
      } else {
        statusObj.robustness = o.robustness;
        if (hdcpStatus === null) {
          hdcpStatus = getHdcpStatus(o, avia);
        }
      }
    }
  });
  if (hdcpStatus === null) {
    hdcpStatus = defaultHdcpStatus;
  }
  return {
    keySystemStatus: statusArray,
    hdcpStatus
  };
}
function getHdcpStatus(data, avia) {
  const hdcpVers = HdcpVersions.slice();
  const hStat = {};
  hdcpVers.forEach((v) => {
    if (!hStat[v]) {
      hStat[v] = {};
    }
    hStat[v].version = v;
    const value = data[v];
    const isUnknown = !value || typeof value !== "string" || value === "null" || value === "undefined";
    if (!isUnknown) {
      let stat = avia.HdcpStatus.UNKNOWN;
      switch (value) {
        case "usable":
          stat = avia.HdcpStatus.USABLE;
          break;
        case "output-restricted":
          stat = avia.HdcpStatus.OUTPUT_RESTRICTED;
          break;
        case "true":
          stat = avia.HdcpStatus.USABLE;
          break;
        case "false":
          stat = avia.HdcpStatus.OUTPUT_RESTRICTED;
          break;
      }
      hStat[v].status = stat;
    } else {
      hStat[v].status = avia.HdcpStatus.UNKNOWN;
    }
  });
  const hdcpStatus = [];
  Object.keys(hStat).forEach((k) => hdcpStatus.push(hStat[k]));
  return hdcpStatus;
}
const HDCP = "hdcp";
function hdcpExtension(options = {}) {
  return (context) => {
    const { avia } = context;
    avia.registerHook(avia.AviaHookType.DEVICE_CAPABILITIES, avia.Util.cache("hdcpCapabilities", () => createDeviceCapabilitiesHook(avia, options)));
  };
}
const ID = HDCP;
const extension = hdcpExtension;
export {
  HDCP,
  ID,
  extension,
  hdcpExtension
};
//# sourceMappingURL=avia.hdcp.esm.js.map
